import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Schedule from './Schedule';
import About from './About';
import Rules from './Rules';
import HoopChallenge from './HoopChallenge';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/about" element={<About />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/100hoop" element={<HoopChallenge />} />
      </Routes>
    </Router>
  );
}

export default App;
